import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StandardCartItemResultLayoutComponentsProviderComponentBase } from '../StandardCartItemResultLayoutComponentsProviderComponentBase';
import { RenderInCartItemResultLayoutDirective } from '../../../../layouts/cart-item/cart-item-result-layout/render-targets';
import { ImageComponent } from 'common-ui';
import {
  ProductIdLabelComponent,
  ProductShortDescriptionComponent,
  ProductIsCanadianComponent,
  ProductNotReturnableComponent,
} from 'products-ui';
import { StandardCartItemSummaryComponent } from '../../standard-cart-item-summary';
import { CartItemQuantitySelectorComponent } from '../../../../common/cart-item-quantity-selector';
import { ProductComponentStore } from 'products-data';

@Component({
  selector: 'ideal-standard-cart-item-result-layout-components-provider',
  imports: [
    RenderInCartItemResultLayoutDirective,
    ImageComponent,
    ProductIdLabelComponent,
    ProductShortDescriptionComponent,
    ProductIsCanadianComponent,
    ProductNotReturnableComponent,
    StandardCartItemSummaryComponent,
    CartItemQuantitySelectorComponent,
  ],
  standalone: true,
  templateUrl: './standard-cart-item-result-layout-components-provider.component.html',
  styleUrl: './standard-cart-item-result-layout-components-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ProductComponentStore],
})
export class StandardCartItemResultLayoutComponentsProviderComponent extends StandardCartItemResultLayoutComponentsProviderComponentBase {}
